export default __webpack_public_path__ + "static/media/Nxrmal_Lo_Head_AO.5f5d2964.tga";